import React from "react";

const logos = [
  "Acoustic.svg",
  "ADN.png",
  "Autoliv.svg",
  "Indiana-Office-of-Technology-1.svg",
  "Johns-Hopkins.svg",
  "K2-Ventures.svg",
  "pollozek-logo.svg",
  "St-John.svg",
  "Three-Phase-Electric-home-page.svg",
  "XoServe-Logo.svg",
  "XoServe-Logo.svg",
  "XoServe-Logo.svg",
  "XoServe-Logo.svg",
];

const Stats = () => {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-6xl mx-auto text-center">

        {/* TITLE */}
        <h2 className="text-4xl md:text-5xl font-bold text-[#0b1f3b] mb-6">
          Our mission: Complete client success
        </h2>

        {/* DESCRIPTION */}
        <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed text-lg mb-16">
          When it comes to digital transformation, why settle for a vendor when
          what you need is a partner? Someone who understands your industry and
          your company and how to execute your strategy efficiently and
          completely. Someone you can count on to deliver essential solutions
          and measurable results again and again. TechSPR is that partner.
        </p>

        {/* LOGO MARQUEE WITH FADE */}
        <div className="logo-wrapper relative overflow-hidden">

          {/* LEFT FADE */}
          <div className="fade-left" />

          {/* RIGHT FADE */}
          <div className="fade-right" />

          {/* TRACK */}
          <div className="logo-track">
            {[...logos, ...logos].map((logo, index) => (
              <div key={index} className="logo-item">
                <img
                  src={`/images/clientslogo/${logo}`}
                  alt="Client logo"
                  className="h-10 object-contain opacity-80 hover:opacity-100 transition"
                />
              </div>
            ))}
          </div>

        </div>

        {/* CTA */}
        <a
          href="#"
          className="inline-flex items-center gap-2 text-orange-500 font-medium hover:underline mt-14"
        >
          Browse Client Success Stories
          <span className="text-xl">→</span>
        </a>

      </div>

      {/* INLINE STYLES */}
      <style>{`
        .logo-wrapper {
          position: relative;
        }

        .logo-track {
          display: grid;
          grid-auto-flow: column;
          grid-template-rows: repeat(2, auto);
          gap: 40px 60px;
          width: max-content;
          animation: scroll 40s linear infinite;
        }

        .logo-item {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 140px;
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }

        /* Pause on hover */
        .logo-track:hover {
          animation-play-state: paused;
        }

        /* FADE EDGES */
        .fade-left,
        .fade-right {
          position: absolute;
          top: 0;
          width: 120px;
          height: 100%;
          z-index: 10;
          pointer-events: none;
        }

        .fade-left {
          left: 0;
          background: linear-gradient(
            to right,
            #ffffff 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }

        .fade-right {
          right: 0;
          background: linear-gradient(
            to left,
            #ffffff 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `}</style>

    </section>
  );
};

export default Stats;
